module.exports = __webpack_public_path__ + "images/applePayIcon-291abe8a8a56664f061ec59d05a83f14.svg";